/*
 * @Author: lzy
 * @Date: 2019-11-13 11:19:51
 * @LastEditTime: 2019-11-17 16:49:40
 * @LastEditors: Please set LastEditors
 * @Description: 头条号路由
 * @FilePath: \xjmediacloud\app\editingCenter\toutiaohao\toutiaohaoRouter.js
 */
angular.module('toutiaohaoRouterModule', []).config([
    '$stateProvider',
    function($stateProvider) {
        $stateProvider.state('front.editctr.toutiaohao', {
            url: '/toutiaohao',
            views: {
                'toutiaohao@front.editctr': {
                    templateUrl: './editingCenter/toutiaohao/left_tpl.html',
                    controller: 'EditToutiaohaoLeftCtrl',
                },
            },
        });
    },
]);
